import styled from "@emotion/styled";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { gray, primary } from "configs/colors";

export const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 4px)",
    right: "calc(50% + 4px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: primary[700],
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: primary[700],
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: gray[200],
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));
